window.bahlsen = (window.bahlsen || {});

/**
 * Utilities for interacting with forms.
 * @class Site
 * @static
 */
bahlsen.Form = (function Form($) {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * jQuery element collections.
   * @private
   */
  var $contact       = $('[data-form="contact"]');
  var $uploadBtn = $('[action-file-sim]');
  var $uploadField = $('#formFiles');
  var $uploadText = $('[action-upload-text]');

  /**
   * Initializes the class.
   * @public
   */
  var init = function() {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    $uploadBtn.on('click', function(e) {
      $uploadField.click();
    })

    $uploadField.on('change', function(e) {
      $uploadText.text($uploadField.val());
    })

    console.log(bahlsen.App.config('csrf'));

    // Initialize forms
    $contact.each(function() {
      initContact($(this));
    });
    // Return success
    return true;

  };

  /**
   * Initialize contact form.
   * @private
   */
  var initContact = function($form) {

    var $error   = $('[data-form-error]', $form);
    var $success = $('[data-form-success]');
    var $fields  = $('[data-form-field]', $form);
    var $button  = $('[data-form-button]', $form);

    /**
     * Submit event
     */
    $form.on('submit', function(e) {

      // Disable button
      e.preventDefault();
      $button.prop('disabled', true);
      $button.addClass('loading');

      // Submit the form
      saveEntry($form);

      // Enable button after 3 seconds
      setTimeout(function() {
        $button.prop('disabled', false);
        $button.removeClass('error success loading');
      }, 3000);

    });

    /**
     * Error event
     */
    $form.on('form.error', function(e, errors) {

      // Show the error alert
      $error.show();
      $success.hide();
      $button.addClass('error');
      $button.removeClass('loading');

      // Reset all fields errors
      $fields.removeClass('error');
      $('.form-error', $fields).hide();

      // Loop through all errors and highlight fields
      $.each(errors, function(key, value) {

        if (key == 'formFiles') {
          key = 'formMessage';
        }

        var $field = $('[data-form-field="' + key + '"]', $form);

        if ($field.length) {
          $field.addClass('error');
          $('.form-error', $field).show();
        } else {
          alert('Server error: ' + key + ' = ' + value);
        }

      });
    });

    /**
     * Success event
     */
    $form.on('form.success', function() {
      // Show the success alert
      $error.hide();
      $success.show();
      $fields.removeClass('error');
      $('.form-error', $fields).hide();

      $button.addClass('success');
      $button.removeClass('loading');
    });

    /**
     * Reset event
     */
    $form.on('form.reset', function() {

      $form.trigger('reset');

      $error.hide();
      $success.hide();
      $fields.removeClass('error');
      $('.form-error', $fields).hide();
      $button.removeClass('error success loading');
      $button.prop('disabled', false);

    });

  };
  /**
   * Save entry through an ajax post.
   * @private
   */
  var saveEntry = function($form) {

    // Use FormData to handle files upload
    var data = new FormData($form[0]);
    data.append('site_csrf', bahlsen.App.config('csrf'));

    // Send form data through an ajax post
    var Request = $.ajax({
      url: '/' + bahlsen.App.config('locale') + '/form/saveEntry',
      type: 'POST',
      data: data,
      cache: false,
      contentType: false,
      processData: false,
    });

    // Request done
    Request.done(function(response) {

      if (response.success && response.success === true) {

        // Trigger the success event
        $form.trigger('form.success');

        // Reset form after 3 seconds
        setTimeout(function() {
          $form.trigger('form.reset');
        }, 3000);

        // Return success
        return true;

      } else if (response.errors) {

        // Trigger the error event
        $form.trigger('form.error', response.errors);

        // Return failure
        return false;

      } else {

        // Return failure
        alert('Server error: Invalid response');
        return false;

      }

    });

    // Request failed
    Request.fail(function(jqXHR, textStatus) {

      alert('Server error: ' + textStatus);

    });

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}(jQuery));
